import { FormikProps } from 'formik';

export const calculateDialogHeight = (
  formik: FormikProps<any>,
  fieldGroups: Array<Array<string>>,
  customBaseHeight = 600
) => {
  const baseHeight = customBaseHeight;
  let errorHeight = 0;

  fieldGroups.forEach((group) => {
    const groupHasError = group.some((field) => {
      return formik.touched[field] && formik.errors[field];
    });
    if (groupHasError) {
      errorHeight += 20;
    }
  });

  return baseHeight + errorHeight;
};

export const calculateDialogHeightByErrorCount = (
  formik: FormikProps<any>,
  baseHeight: number,
  errorHeightIncrement: number
) => {
  const errorsCount = Object.keys(formik.errors).filter((key) => {
    const touched = formik.touched as Record<string, any>;
    const errors = formik.errors as Record<string, any>;
    return touched[key] && errors[key];
  }).length;

  return baseHeight + errorsCount * errorHeightIncrement;
};

export const calculateDialogHeightByItemCount = (
  itemCount: number,
  baseHeight = 620,
  itemHeight = 100
) => {
  const additionalItems = Math.max(0, itemCount - 1);
  return baseHeight + additionalItems * itemHeight;
};
